<template>
  <footer class="footer bg-dark text-white py-4">
    <div class="container">
      <div class="row g-4">
        <div class="col-lg-5">
          <h5 class="mb-2 fw-bold d-flex align-items-center">
            <div class="brand-icon me-2">
              <i class="bi bi-building"></i>
              <i class="bi bi-car-front position-absolute"></i>
            </div>
            ImmobilAutoManager
          </h5>
          <p class="mb-3 text-light-gray">
            La soluzione completa per la gestione di immobili e auto.
          </p>
          <div class="social-links">
            <a href="#" class="social-link"><i class="bi bi-facebook"></i></a>
            <a href="#" class="social-link"><i class="bi bi-twitter"></i></a>
            <a href="#" class="social-link"><i class="bi bi-linkedin"></i></a>
          </div>
        </div>
        <div class="col-lg-3">
          <h5 class="footer-title">Link Utili</h5>
          <ul class="list-unstyled footer-links">
            <li><router-link to="/">Home</router-link></li>
            <li><router-link :to="{name: 'features'}">Caratteristiche</router-link></li>
            <li><router-link :to="{name: 'about'}">Chi Siamo</router-link></li>
            <li><router-link :to="{name: 'pricing'}">Prezzi</router-link></li>
            <li><router-link :to="{name: 'privacy'}">Privacy Policy</router-link></li>
            <li><router-link :to="{name: 'cookies'}">Cookie Policy</router-link></li>
          </ul>
        </div>
        <div class="col-lg-4">
          <h5 class="footer-title">Contatti</h5>
          <ul class="list-unstyled footer-contact">
            <li><i class="bi bi-envelope me-2"></i>info@immobilautoFVG.it</li>
            <li><i class="bi bi-telephone me-2"></i>+39 0432 123456</li>
            <li><i class="bi bi-geo-alt me-2"></i>Via Udine, 123 - 33100 Udine (UD)</li>
          </ul>
        </div>
      </div>
      <hr class="my-4 border-secondary">
      <div class="text-center">
        <small class="text-light-gray">&copy; 2024 ImmobilAutoManager. Tutti i diritti riservati.</small>
      </div>
    </div>
  </footer>
</template>

<style scoped>
.footer {
  background: #023047;
}

.text-light-gray {
  color: #8ecae6;
}

.footer-title {
  font-weight: 600;
  margin-bottom: 1rem;
  position: relative;
}

.footer-links li {
  margin-bottom: 0.5rem;
}

.footer-links a {
  color: #8ecae6;
  text-decoration: none;
  transition: all 0.3s ease;
}

.footer-links a:hover {
  color: #ffb703;
  padding-left: 5px;
}

.footer-contact li {
  margin-bottom: 0.75rem;
  color: #a0a0a0;
}

.social-links {
  display: flex;
  gap: 1rem;
}

.social-link {
  color: #8ecae6;
  text-decoration: none;
  font-size: 1.2rem;
  transition: all 0.3s ease;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(142, 202, 230, 0.1);
}

.social-link:hover {
  background: #219ebc;
  color: #ffb703;
  transform: translateY(-3px);
}

@media (max-width: 991.98px) {
  .footer-title {
    margin-bottom: 0.75rem;
  }

  .social-links {
    margin-bottom: 1.5rem;
  }
}

.brand-icon {
  position: relative;
  width: 1.5rem;
  height: 1.5rem;
}

.brand-icon i:first-child {
  font-size: 1.2rem;
}

.brand-icon i:last-child {
  font-size: 0.9rem;
  bottom: -3px;
  right: -5px;
}
</style>
